import "./BreadcrumbComponent.scss";
import PropTypes from "prop-types";
import { getRouterForSection, routesMap } from "../../routes";
import { useNavigate } from "react-router-dom";

/**
 * @function BreadcrumbComponent 
 * @param items path to view
 * @returns {JSX.Element}
*/
const BreadcrumbComponent = ({ items }) => {

  const navigate = useNavigate();
  const redirecTo = (sezione, categoria) => {
    if (categoria)
      navigate(`${routesMap.DETAGLIO_CATEGORIA}/${categoria.idContenuto}`);
    else if (sezione) {
      navigate( getRouterForSection(sezione?.tipologia) );
    }
    else
      navigate(routesMap.HOME_PAGE);
  }

  return (

    <nav className="breadcrumb-container" aria-label="Percorso di navigazione">
      <ol className="breadcrumb pt-0 pb-3 m-0">
        { items.map((item, index) => {
          const { name, href, sezione, categoria } = item;
          const lastItem = items.length - 1 === index;
          return (
            <li className="breadcrumb-item" key={ name }>
              <a href={ href } onClick={ () => redirecTo(sezione, categoria) }>{ name }</a>{ !lastItem && <span className="separator">&gt;</span> }
            </li>
          );
        }) }
      </ol>
    </nav>
  );
};

BreadcrumbComponent.propTypes = {
  items: PropTypes.array
};

BreadcrumbComponent.defaultProps = {
  items: []
};

export default BreadcrumbComponent;